import { useState } from "react";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";
import { api } from "../api";
import { showToast } from "../../../../utils/showToast";

//TODO: duplicated logic also in UploadGoals, UploadReferrals
export default function useUploadXlsx() {
  const [error, setError] = useState("");
  const [file, setFile] = useState("");

  const onFileUpload = (e) => {
    let file = e.target.files[0];

    if (
      file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.type !== "application/vnd.ms-excel"
    ) {
      setError("Please select correct file type.");
      setFile("");
    } else {
      setError("");
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadstart = () => setFile("");
      reader.onload = () => setFile(reader.result);
    }
  };

  const request = async () => {
    try {
      const { short_url } = getBaseUrlParams();

      let res = await api.importRevenueCategories({ short_url, file });
      showToast(res.data.message);
    } catch (err) {
      showToast(err.response.error);
      console.log(err);
    }
  };

  return { error, file, onFileUpload, request };
}
